/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/documentation/documentation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { DocumentationRoutingModule } from "./documentation-routing.module";
import * as i0 from "@angular/core";
export class DocumentationModule {
    constructor() {
    }
}
DocumentationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    DocumentationRoutingModule,
                ],
            },] },
];
/** @nocollapse */
DocumentationModule.ctorParameters = () => [];
/** @nocollapse */ DocumentationModule.ɵmod = i0.ɵɵdefineNgModule({ type: DocumentationModule });
/** @nocollapse */ DocumentationModule.ɵinj = i0.ɵɵdefineInjector({ factory: function DocumentationModule_Factory(t) { return new (t || DocumentationModule)(); }, imports: [[
            DocumentationRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DocumentationModule, { imports: [DocumentationRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DocumentationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    DocumentationRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnRhdGlvbi5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9kb2N1bWVudGF0aW9uL2RvY3VtZW50YXRpb24ubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsMEJBQTBCLEVBQUMsTUFBTSxnQ0FBZ0MsQ0FBQzs7QUFPMUUsTUFBTSxPQUFPLG1CQUFtQjtJQUM5QjtJQUFlLENBQUM7OztZQU5qQixRQUFRLFNBQUM7Z0JBQ1IsT0FBTyxFQUFHO29CQUNSLDBCQUEwQjtpQkFDM0I7YUFDRjs7Ozt1REFDWSxtQkFBbUI7cUhBQW5CLG1CQUFtQixrQkFKcEI7WUFDUiwwQkFBMEI7U0FDM0I7d0ZBRVUsbUJBQW1CLGNBSDVCLDBCQUEwQjtrREFHakIsbUJBQW1CO2NBTC9CLFFBQVE7ZUFBQztnQkFDUixPQUFPLEVBQUc7b0JBQ1IsMEJBQTBCO2lCQUMzQjthQUNGIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtOZ01vZHVsZX0gZnJvbSBcIkBhbmd1bGFyL2NvcmVcIjtcbmltcG9ydCB7RG9jdW1lbnRhdGlvblJvdXRpbmdNb2R1bGV9IGZyb20gXCIuL2RvY3VtZW50YXRpb24tcm91dGluZy5tb2R1bGVcIjtcblxuQE5nTW9kdWxlKHtcbiAgaW1wb3J0cyA6IFtcbiAgICBEb2N1bWVudGF0aW9uUm91dGluZ01vZHVsZSxcbiAgXSxcbn0pXG5leHBvcnQgY2xhc3MgRG9jdW1lbnRhdGlvbk1vZHVsZSB7XG4gIGNvbnN0cnVjdG9yKCkge31cbn1cbiJdfQ==